import { ContestViewEntry, User } from '@freelancer/datastore';

export enum ContestAwardModalResponse {
  AWARD_MULTIPLE,
}

export interface ContestAwardModalDetails {
  readonly entry: ContestViewEntry;
  readonly freelancer: User;
  readonly canMultiAward: boolean;
}
